import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./NovoSistema.module.css";
import SistemaApi from "../../services/SistemaApi";
import { Form } from "react-bootstrap";
import Alerta from "../../components/alerta/Alerta";
import BotaoSalvar from "../../components/botaoSalvar/BotaoSalvar";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";


function NovoSistema() {
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

  const [novoSistema, setNovoSistema] = useState({
    nome: "",
    descricao: "",
    url: "",
  });
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const exibirAlerta = (mensagem, tipo) => {
    setMensagemAlerta(mensagem);
    setTipoAlerta(tipo);
    setMostrarAlerta(true);

    // Após exibir o alerta, redirecionar depois de 5 segundos
    setTimeout(() => {
      setMostrarAlerta(false);
      if (tipo === "success") {
        navigate("/backoffice/sistema", {
          state: {
            mensagem: mensagem,
            tipo: tipo
          }
        }, 500);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isFormValid()) {
        setLoading(true);
        await SistemaApi.AdicionarSistema(novoSistema);
        exibirAlerta("Sistema adicionado com sucesso!", "success");
      } else {
        exibirAlerta("Por favor, preencha todos os campos.", "warning");
      }
    } catch (error) {
      exibirAlerta(
        "Erro ao adicionar o sistema. Verifique os dados.",
        "danger"
      );
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNovoSistema((prevSistema) => ({
      ...prevSistema,
      [name]: value,
    }));
  };

  const isFormValid = () => {
    return novoSistema.nome && novoSistema.descricao && novoSistema.url;
  };

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto}
      setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar
        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}
      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        <div className={style.pagina_conteudo}>
          <h4>Novo Sistema</h4>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formNomeSistema" className="mb-3">
              <Form.Label>Nome do Sistema</Form.Label>
              <InputBuscar
                maxLength={100}
                type="text"
                placeholder="Digite o nome do sistema"
                name="nome"
                value={novoSistema.nome}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formUrlSistema" className="mb-3">
              <Form.Label>URL do Sistema</Form.Label>
              <InputBuscar
                maxLength={150}
                type="text"
                placeholder="Digite a URL do sistema"
                name="url"
                value={novoSistema.url}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formDescricaoSistema" className="mb-3">
              <Form.Label>Descrição do Sistema</Form.Label>
              <InputBuscar
                maxLength={300}
                as="textarea"
                placeholder="Digite a descrição do sistema"
                name="descricao"
                value={novoSistema.descricao}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <BotaoSalvar isDisabled={!isFormValid()} />
          </Form>
        </div>
      </Topbar>
    </Sidebar>
  );
}

export default NovoSistema;
